import React, { useState, useEffect } from "react";
import styled from "styled-components";
import StarRating from ".././StarRating";
import PersistentModal from "../../../interface/PersistentModal";
import ActiveFaultsDetailsTabForm from "./DetailsTabForm";

const CardContainer = styled.div`
  width: fit-content;

  flex-shrink: 0;
  position: relative;
  display: flex;
  margin-right: 0.5rem;

  align-items: center;
  justify-content: center;
  padding-right: 0.9rem;
  overflow: hidden;
  transition: transform 1.3s ease-in-out, opacity 1.3s ease-in-out;
`;

const Card = styled.div`
  position: relative;
  width: 85vw;
  height: 14em;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  margin-bottom: 1em;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1.5em 1em;
  border-radius: 10px;
  backdrop-filter: blur(30px);
  background-color: var(--backdrop-color);
  border: 1px solid var(--color-grey-200);
  cursor: pointer;
  box-shadow: var(--shadow-div-md);
`;

const StatusGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -1rem;
  margin-bottom: 1rem;
`;

const Duration = styled.div`
  font-weight: 700;
  font-size: 1.4em;
  letter-spacing: 1.2px;
  color: var(--color-grey-900);
`;

const Info = styled.div`
  font-weight: 500;
  font-size: 0.9em;
  color: var(--color-grey-700);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Location = styled.div`
  font-size: 1.2em;
  color: var(--color-grey-900);
`;

const LocContainer = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1em;
`;

const InfoBox = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  gap: 4px;

  &:not(:last-child) {
    border-right: 1px solid var(--color-witron-blue);
  }
`;

const InfoHeading = styled.div`
  font-size: 0.6em;
  font-weight: 600;
  color: var(--color-witron-blue);
`;

const InfoValue = styled.div`
  font-size: 0.9em;
  font-weight: 500;
  color: var(--color-grey-800);
  min-height: 1em; /* Ensure consistent height */
`;

function FaultCard({ fault, direction }) {
  const [timeDifference, setTimeDifference] = useState(fault.duration);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDifference((prev) => prev + 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const hours = String(Math.floor(timeDifference / (1000 * 60 * 60))).padStart(
    2,
    "0"
  );
  const minutes = String(
    Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
  ).padStart(2, "0");
  const seconds = String(
    Math.floor((timeDifference % (1000 * 60)) / 1000)
  ).padStart(2, "0");

  function mapPriorityToStars(priority) {
    switch (priority) {
      case 1:
        return 4; // 1 translates to 4 stars
      case 2:
        return 3; // 2 translates to 3 stars
      case 3:
        return 2; // 3 translates to 2 stars
      case 4:
        return 1; // 4 translates to 1 star
      case 5:
      case null:
      default:
        return 0; // 5 or null translates to 0 stars
    }
  }

  function handleCardClick() {
    console.log("card clicked");
    return <div></div>;
  }

  const translatedRating = mapPriorityToStars(fault.priority);

  return (
    <CardContainer>
      <PersistentModal>
        <PersistentModal.Open opens="settings">
          <Card>
            <StatusGroup>
              <Duration>{`${hours}:${minutes}:${seconds}`}</Duration>
              <StarRating defaultRating={translatedRating} />
            </StatusGroup>
            <Info>{fault.faultInfo}</Info>
            <Location>{fault.locationRaw}</Location>
            <LocContainer>
              <InfoBox>
                <InfoHeading>GC</InfoHeading>
                <InfoValue>{fault.gc}</InfoValue>
              </InfoBox>
              <InfoBox>
                <InfoHeading>LAC</InfoHeading>
                <InfoValue>{fault.lac}</InfoValue>
              </InfoBox>
              <InfoBox>
                <InfoHeading>POS</InfoHeading>
                <InfoValue>{fault.pos}</InfoValue>
              </InfoBox>
            </LocContainer>
          </Card>
        </PersistentModal.Open>
        <PersistentModal.Window name="settings">
          <ActiveFaultsDetailsTabForm fault={fault} />
        </PersistentModal.Window>
      </PersistentModal>
    </CardContainer>
  );
}

export default FaultCard;
